import { InputHTMLAttributes } from "react";
import LabelWrapper, { TypeLabelWrapper } from "./label-wrapper";

export type TypeInputBox = TypeLabelWrapper & { error?: boolean } & Pick<
    InputHTMLAttributes<HTMLInputElement>,
    | "type"
    | "value"
    | "onChange"
    | "prefix"
    | "disabled"
    | "className"
    | "placeholder"
  >;

const InputBox = ({
  label,
  value,
  onChange,
  prefix,
  disabled = false,
  required = false,
  type = "text",
  className = "",
  placeholder,
  error = false,
}: TypeInputBox) => {
  return (
    <LabelWrapper label={label} required={required}>
      <div
        className={`flex items-center space-x-4 rounded-l-6 rounded-r-6 border text-13 ${
          error
            ? "border-darwin-status-warning-500"
            : disabled
            ? "bg-seperator-dark border-neutral-10"
            : "border-neutral-7"
        } ${className}`}
      >
        {!!prefix && (
          <div className="px-4 py-8 rounded-l-6 text-neutral-3 bg-neutral-9">
            {prefix}
          </div>
        )}
        <input
          placeholder={placeholder}
          disabled={disabled}
          type={type}
          className={`w-full px-4 py-8 focus:outline-none rounded-6 ${
            disabled ? "text-darwin-neutral-600" : "text-neutral-2"
          }`}
          value={value}
          onChange={onChange}
        />
      </div>
    </LabelWrapper>
  );
};

export default InputBox;
